<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">      
      <div class="eleven wide computer sixteen wide tablet sixteen wide mobile column">
        <button class="ui blue button" @click="$refs.formModal.create()">
          <i class="plus icon"></i> Nova Raça
        </button>
      </div>
      <div class="five wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui basic right aligned segment no-padding no-margin">
          <div class="ui form">
            <div class="field">
              <search-input id="races-search-input" ref="searchInput" @onSearch="search" />
            </div>
          </div>    
        </div> 
      </div>
    </div>

    <data-table id="races-dtbl" ref="dtbl" :service="service" :attributes="attributes" :fields="fields" @onRowClick="onUpdate" />

    <form-modal ref="formModal" @onSave="refresh" @onRemove="refresh" />

  </div>

</template>

<script>
  
  import RaceService from "@/services/race-service"
  import FormModal from "./form-modal"
  import { gridPage, onlySimavet } from "@/mixins"

  export default {    

    name: "RacesPage",

    mixins: [gridPage, onlySimavet],

    data() {
      return {        
        title: "Raças",
        service: new RaceService(),
        attributes: ["id", "name", "speciesId"],
        fields: [          
          { prop: "name", label: "Nome da Raça" },
          { prop: "species.name", model: "Species", label: "Espécie" },
        ],
      }
    },

    components: {
      FormModal,
    },

    methods: {

      onUpdate(data) {
        this.$refs.formModal.update(data.row)
      }
    },
  }

</script>
